export const initialViewport = {
  bearing: 0,
  latitude: 37.8191897,
  longitude: -122.172776,
  pitch: 0,
  zoom: 10,
};
